/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as SignatureDefs from './defs.defs.js'

const $nsid = 'tools.ozone.signature.findCorrelation'

export { $nsid }

/** Find all correlated threat signatures between 2 or more accounts. */
const main = l.query(
  $nsid,
  l.params({ dids: l.array(l.string({ format: 'did' })) }),
  l.jsonPayload({
    details: l.array(
      l.ref<SignatureDefs.SigDetail>((() => SignatureDefs.sigDetail) as any),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
